import { atom } from "jotai";
import { isReplayingAtom, store } from ".";

export enum SidebarStatus {
  Open = 'open',
  Close = 'close',
  FullScreen = 'full-screen',
}

export enum SidebarTab {
  Code = 'code',
  Preview = 'preview',
}

export const sidebarLayoutAtom = atom<{
  defaultSidebarWidth?: number;
  selectedTab: string;
  sidebarStatus: SidebarStatus,
  enableFullScreenTrigger?: boolean
  tabs: {
    id: string,
    title: string,
    visible: boolean,
    loading: boolean,
    content: React.ReactNode
  }[]
}>({
  selectedTab: '',
  enableFullScreenTrigger: false,
  sidebarStatus: SidebarStatus.Close,
  tabs: []
});

export const setSidebarStatusAtom = atom(null, (_, set, status: SidebarStatus) => {
  set(sidebarLayoutAtom, (prev) => ({
    ...prev,
    sidebarStatus: status
  }));
});

export const setSelectedTabAtom = atom(null, (_, set, tabId: string) => {
  set(sidebarLayoutAtom, (prev) => ({
    ...prev,
    selectedTab: tabId
  }));
});


export const getSidebarTabsAtom = atom(get => {
  const isReplaying = get(isReplayingAtom);
  return get(sidebarLayoutAtom).tabs.filter(tab => isReplaying || tab.visible).map(tab => {
    return {
      id: tab.id,
      title: tab.title,
    }
  })
});

export const getContentFromTabAtom = atom(get => {
  const { selectedTab, tabs, sidebarStatus } = get(sidebarLayoutAtom);
  const isClose = sidebarStatus === SidebarStatus.Close;
  if (isClose) return null;
  const activeTab = tabs.find(tab => tab.id === selectedTab);
  return activeTab ? activeTab.content : null;
});

export const setSidebarTabAtom = atom(null, (_, set, tabId: string) => {
  set(sidebarLayoutAtom, (prev) => ({
    ...prev,
    selectedTab: tabId
  }));
});



export const setCurrentTabLoadingAtom = atom(null, (_, set, loading: boolean) => {
  const { selectedTab } = store.get(sidebarLayoutAtom);
  set(sidebarLayoutAtom, (prev) => {
    const tabs = prev.tabs.map(tab => {
      if (tab.id === selectedTab) {
        return { ...tab, loading };
      }
      return tab;
    });
    return { ...prev, tabs };
  });
});

export const getCurrentTabLoadingAtom = atom(get => {
  const { selectedTab, tabs } = get(sidebarLayoutAtom);
  const activeTab = tabs.find(tab => tab.id === selectedTab);
  if (typeof activeTab === 'undefined') {
    return false;
  }
  return activeTab.loading;
});

export const getSidebarOpenedAtom = atom(get => {
  const { sidebarStatus } = get(sidebarLayoutAtom);
  return sidebarStatus !== SidebarStatus.Close;
});
